export default __webpack_public_path__ + "static/media/zoho-icon.12e81b63.png";